// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 570) return "js/js/system.js";
	if (chunkId === 795) return "js/js/auth.js";
	if (chunkId === 859) return "js/js/dashboard.js";
	if (chunkId === 301) return "js/js/search.js";
	if (chunkId === 73) return "js/js/accounts.js";
	if (chunkId === 867) return "js/js/datatank_settings.js";
	if (chunkId === 640) return "js/js/client_settings.js";
	// return url for filenames based on template
	return undefined;
};